export const calculateSum = (obj, field) =>
  obj.map((items) => items[field]).reduce((prev, curr) => prev + curr, 0);
export const convertFloat = (value) => {
  try {
    value = value.replace(/,/g, '');
    return parseFloat(value);
  } catch (error) {
    return 0;
  }
};
export const convertToNumber = (text) => {
  return text ? parseFloat((text + '').replace(/,/g, '')) : 0;
};
